import { render, staticRenderFns } from "./RegisterAdditionalModalComplete.vue?vue&type=template&id=4149f03a&"
import script from "./RegisterAdditionalModalComplete.vue?vue&type=script&lang=ts&"
export * from "./RegisterAdditionalModalComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports